/* global fetchProcurementPlanItemUrl */

import React, { useEffect, useState } from 'react';

import ProcurementModalContent from '../../../procurement_plan/ProcurementModalContent';

import RecipientsField from './RecipientsField';

/**
 * The requisition's own procurement detail, rendered by the same component the
 * module's approval modal uses, plus the recipients picker.
 *
 * The detail is fetched on open exactly as that modal does — the register row
 * carries the requisition, not the procurement plan item behind it.
 */
export default function PurchaseRequisitionBody({ row, myViews, onExtrasChange, readOnly }) {
    const [procurement, setProcurement] = useState({});

    const record = row?.record ?? {};

    useEffect(() => {
        if (!record.procurement_plan_item_id) {
            setProcurement({});

            return;
        }

        axios
            .get(fetchProcurementPlanItemUrl.replace('ITEM_ID', record.procurement_plan_item_id))
            .then(({ data }) => setProcurement(data))
            .catch(() => setProcurement({}));
    }, [record.procurement_plan_item_id]);

    return (
        <div>
            <ProcurementModalContent procurement={procurement} downloadAttachmentUrl={myViews.download_attachment_url} />

            {!readOnly && (
                <RecipientsField
                    enabled={!!myViews.pr_approval_email_enabled}
                    requestor={record.owner || record.requested_by}
                    approvers={record.approval_history || record.approvers || []}
                    defaultRecipients={myViews.pr_approval_email_recipients}
                    onChange={(additionalRecipients) => onExtrasChange?.({ additionalRecipients })}
                />
            )}
        </div>
    );
}
